<template>
    <div class='h-full'>
        <v-card class="h-full">
            <div class="account">
                <div class="sub-title" :class="$vuetify.theme.dark ? 'sub-title-d': 'sub-title-l'">
                    <img src="@/assets/img/border.png" alt="">
                    <span>{{$t('account.title')}}</span>
                </div>
                <div class="box">
                    <v-container class="pa-0" fluid fill-height>
                        <v-row no-gutters class="h-full">
                            <v-col
                                cols="12"
                                class="list"  :class="$vuetify.theme.dark ? 'list-d': ''" v-for="(item, index) in dataList" :key="index" v-if="(item.key == 1 && showEditPwd) || item.key != 1">
                                    <v-row class="ma-4">
                                        <v-col cols="12" md="2" lg="2" xl="1" sm="2">
                                            <img :src="item.pic" alt="" style="width: 82px;">
                                        </v-col>
                                        <v-col cols="12" md="6" lg="6" xl="8" sm="6">
                                            <div class="text-box">
                                                <div class="item-title">{{item.title}}</div>
                                                <div class="text" v-if="item.key == 2">{{obgData.mobile ? $t('account.phone.tip01')+obgData.mobile+$t('account.phone.tip02'):$t('account.phone.tip03')}}</div>
                                                <div class="text" v-else-if="item.key == 3">{{obgData.existEmail ? $t('account.email.tip01')+obgData.emailCopy+$t('account.email.tip02'):$t('account.email.tip03')}}</div>
                                                <div class="text" v-else-if="item.key == 7">{{hardwareType ? $t('account.hardware.tip01')+otpNum+$t('account.hardware.tip02') : $t('account.hardware.tip03')}}</div>
                                                <div class="text" v-else-if="item.key == 8">{{FIDOU2FType ? $t('account.FIDOU2F.tip01')+FIDOU2FNum+$t('account.FIDOU2F.tip02') : $t('account.FIDOU2F.tip03')}}</div>
                                                <div class="text" v-else-if="item.key == 4">{{dynamicType == 1 ? $t('account.dynamic.tip01') : item.text}} </div>
                                                <div class="text" v-else-if="item.key == 9">{{windowsHello ?$t('account.webAuthn.tip01') + FIDOU2WebAuthnNum + $t('account.webAuthn.tip02') : $t('account.webAuthn.text')}} </div>
                                                <div class="text" v-else-if="item.key == 5">{{FIDOType ? $t('account.FIDO.tip01') : item.text}} </div>
                                                <div class="text" v-else>{{item.text}}</div>
                                            </div>
                                        </v-col>
                                        <v-col cols="6" md="2" lg="2" xl="1" sm="2" class="text-center">
                                            <div class="tip">
                                                <div v-if="item.key == 1" class="color_bg" :style="{background:existPwd ? '#0ab39c' : '#ccc'}">{{existPwd ? $t('account.haveSet') : $t('account.noSet')}}</div>
                                                <div v-else-if="item.key == 2" class="color_bg" :style="{background:existPhone ? '#0ab39c' : '#ccc'}">{{existPhone ? $t('account.isBind') : $t('account.noBind')}}</div>
                                                <div v-else-if="item.key == 3" class="color_bg" :style="{background:existEmail ? '#0ab39c' : '#ccc'}">{{existEmail ? $t('account.isBind') : $t('account.noBind')}}</div>
                                                <div v-else-if="item.key == 4" class="color_bg" :style="{background:dynamicType ? '#0ab39c' : '#ccc'}">{{dynamicType == 1 ? $t('account.activated') : $t('account.nonactivated')}}</div>
                                                <div v-else-if="item.key == 5" class="color_bg" :style="{background:FIDOType ? '#0ab39c' : '#ccc'}">{{FIDOType ? $t('account.activated') : $t('account.nonactivated')}}</div>
                                                <div v-else-if="item.key == 7" class="color_bg" :style="{background:hardwareType ? '#0ab39c' : '#ccc'}">{{hardwareType ? $t('account.isBind') : $t('account.noBind')}}</div>
                                                <div v-else-if="item.key == 8" class="color_bg" :style="{background:FIDOU2FType ? '#0ab39c' : '#ccc'}">{{FIDOU2FType ? $t('account.isBind') : $t('account.noBind')}}</div>
                                                <div v-else-if="item.key == 9" class="color_bg" :style="{background:windowsHello ? '#0ab39c' : '#ccc'}">{{windowsHello ? $t('account.isBind') : $t('account.noBind')}}</div>
                                                <!-- <div v-else-if="item.key != 6">{{item.type == 0 ? '未激活':'已激活'}}</div> -->
                                            </div>
                                        </v-col>
                                        <v-col cols="6" md="2" lg="2" xl="2" sm="2" class="text-center">
                                            <div class="btn-group" @click="rowFun(item)">
                                                <v-btn color="primary" shape="round" v-if="item.key != 10" small style="font-size:14px;">
                                                    <template v-if="item.key == 1"><v-icon size="16" style="margin-right:8px;" v-show="existPwd" >{{svgPath}}</v-icon><v-icon size="16" style="margin-right:8px;" v-show="!existPwd">{{svgPathCog}}</v-icon>{{existPwd ? $t('account.edit') : $t('account.set')}}</template>
                                                    <template v-else-if="item.key == 2"><v-icon size="16" style="margin-right:8px;" v-show="existPhone">{{svgPath}}</v-icon><v-icon size="16" style="margin-right:8px;" v-show="!existPhone">{{svgPathConnect}}</v-icon>{{existPhone ? $t('account.edit') : $t('account.bind')}}</template>
                                                    <template v-else-if="item.key == 3"><v-icon size="16" style="margin-right:8px;" v-show="existEmail">{{svgPath}}</v-icon><v-icon size="16" style="margin-right:8px;" v-show="!existEmail">{{svgPathConnect}}</v-icon>{{existEmail ? $t('account.edit') : $t('account.bind')}}</template>
                                                    <template v-else-if="item.key == 4"><v-icon size="16" style="margin-right:8px;" v-show="dynamicType">{{svgPathAutor}}</v-icon><v-icon size="16" style="margin-right:8px;" v-show="!dynamicType">{{svgPathKey}}</v-icon>{{dynamicType ? $t('account.reset') : $t('account.activate')}}</template>
                                                    <template v-else-if="item.key == 5"><v-icon size="16" style="margin-right:8px;" v-show="FIDOType">{{svgPathAutor}}</v-icon><v-icon size="16" style="margin-right:8px;" v-show="!FIDOType">{{svgPathKey}}</v-icon>{{FIDOType ? $t('account.reset') : $t('account.activate')}}</template>
                                                    <template v-else-if="item.key == 7"><v-icon size="16" style="margin-right:8px;" v-show="hardwareType">{{svgPathCog}}</v-icon><v-icon size="16" style="margin-right:8px;" v-show="!hardwareType">{{svgPathConnect}}</v-icon>{{hardwareType ? $t('account.set') : $t('account.bind')}}</template>
                                                    <template v-else-if="item.key == 8"><v-icon size="16" style="margin-right:8px;" v-show="FIDOU2FType">{{svgPathCog}}</v-icon><v-icon size="16" style="margin-right:8px;" v-show="!FIDOU2FType">{{svgPathConnect}}</v-icon>{{FIDOU2FType ? $t('account.set') : $t('account.bind')}}</template>
                                                    <template v-else-if="item.key == 9"><v-icon size="16" style="margin-right:8px;" v-show="windowsHello">{{svgPathCog}}</v-icon><v-icon size="16" style="margin-right:8px;" v-show="!windowsHello">{{svgPathConnect}}</v-icon>{{windowsHello ? $t('account.set') : $t('account.bind')}}</template>
                                                    <template v-else><v-icon size="16" style="margin-right:8px;">{{svgPathEye}}</v-icon>{{$t('account.look')}}</template>
                                                </v-btn>
                                                <!-- <v-btn color="primary" shape="round" v-if="item.key == 10"> -->
                                                    <template v-if="item.key == 10">
                                                        <a   href="/download/FastLogin.zip" download="FastLogin.zip" style="text-decoration: none;">
                                                            <v-btn color="primary" shape="round"  small style="font-size:14px;">
                                                                <v-icon size="14" style="margin-right:3px;color: #fff;margin-top: -2px;">{{svgPathDown}}</v-icon>
                                                                {{ $t('account.fastLogin.down') }}
                                                            </v-btn>
                                                        </a>
                                                    </template>
                                                <!-- </v-btn> -->
                                            </div>
                                        </v-col>
                                    </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </div>
        </v-card>
        <v-dialog
            content-class="edit-pwd-box"
            v-model="visible"
            :visible="visible"
            persistent
            :width="$vuetify.breakpoint.smAndUp ? modalWidth : '100%'"
            v-if="visible"
            @cancel="handleCancel">
            <v-card>
                <div class="drawer-header d-flex align-center mb-4">
                    <span class="font-weight-semibold text-base text--primary">{{modalTitle}}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        small
                        @click="handleCancel"
                        >
                        <v-icon size="22">
                            {{ icons.mdiClose }}
                        </v-icon>
                    </v-btn>
                </div>
                <!-- <div class="drawer-header d-flex align-center mb-4">
                    <span class="font-weight-semibold text-base text--primary">{{modalTitle}}</span>
                    <v-spacer></v-spacer>

                </div> -->
                <v-card-text style="text-align:center;">
                    <!-- 登录密码 -->
                    <VLogin v-if="activeKey == '1'" :dataType="existPwd" @close="handleCancel" @onSubmit="onSubmit"></VLogin>
                    <!-- 绑定手机 -->
                    <VPhone v-else-if="activeKey == '2'" :dataType="existPhone" @close="handleCancel" @onSubmit="onSubmit"></VPhone>
                    <!-- 绑定邮箱 -->
                    <VEmail v-else-if="activeKey == '3'" :dataType="existEmail" @close="handleCancel" @onSubmit="onSubmit"></VEmail>
                    <!-- 动态口令 -->
                    <VDynamic v-else-if="activeKey == '4'" :dataList="obgData" :dataType="dynamicType" @close="handleCancel" @subFun="dynamicFun" @onSubmit="onSubmit"></VDynamic>
                    <!-- 飞天云信令（FIDO） -->
                    <FIDO v-else-if="activeKey == '5'" :dataList="obgData" :dataType="FIDOType" @close="handleCancel" @subFun="FIDOFun" @onSubmit="onSubmit"></FIDO>
                    <!-- 多因素设置 -->
                    <VSetting v-else-if="activeKey == '6'" @close="handleCancel"></VSetting>
                    <!-- 绑定硬件 -->
                    <VHardware v-else-if="activeKey == '7'" :dataList="obgData" :dataType="hardwareType" @close="handleCancel" @onSubmit="onSubmit"></VHardware>
                    <!-- FIDO U2F硬件令牌 -->
                    <FIDOU2F v-else-if="activeKey == '8'" :dataList="obgData" :dataType="FIDOU2FType" @close="handleCancel" @onSubmit="onSubmit"></FIDOU2F>
                    <!-- FIDO2（WebAuthn）身份验证器 -->
                    <WebAuthn v-else-if="activeKey == '9'" :dataList="obgData"  :dataType="windowsHello" @close="handleClose" @onSubmit="onSubmit"></WebAuthn>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import VLogin from './login'
import VPhone from './phone'
import VEmail from './email'
import VDynamic from './dynamic'
import FIDO from './FIDO'
import VSetting from './setting'
import VHardware from './hardware'
import FIDOU2F from './FIDOU2F'
import store from '@/store'
import WebAuthn from './webAuthn'
import { getUserAccountSecurity, resetUserPwd, setUserPwd, updatePhone, getUserActivationStatus, checkMobileToken } from "@/api/index";
import { mdiPencilOutline,mdiConnection,mdiCogOutline,mdiAutorenew,mdiKeyWireless,mdiEyeOutline,mdiClose,mdiArrowCollapseDown    } from '@mdi/js'

export default {
    components: {
        VLogin, VPhone, VEmail, VDynamic, FIDO, VSetting, VHardware, FIDOU2F, WebAuthn
    },
    data() {
        return {
            svgPath: mdiPencilOutline,
            svgPathConnect: mdiConnection,
            svgPathCog: mdiCogOutline,
            svgPathAutor: mdiAutorenew,
            svgPathKey: mdiKeyWireless,
            svgPathEye: mdiEyeOutline,
            svgPathDown: mdiArrowCollapseDown ,
            icons: {
                mdiClose
            },
            dataList: [],
            visible: false,
            activeKey: 0,
            modalTitle: '',
            // dataType: null, // 0 未激活， 1 激活
            modalWidth: 600,
            existPwd: false,
            existPhone: false,
            existEmail: false,
            FIDOType: false,
            dynamicType: false,
            hardwareType: false,
            obgData: {},
            otpNum: 0,
            FIDOU2FType: false,
            FIDOU2FNum: 0,
            FIDOU2WebAuthnNum:0,
            showEditPwd: false,
            windowsHello: false
        };
    },
    created() {
        this.getData()
        this.getState()
        this.getJurisdiction()
    },

  methods: {
        getData() {
            let creatorId = this.$cookieStore.getCookie("userInfo").creatorId
            if(creatorId > 0){
                this.dataList = [
                    { key: 1, pic: require('@/assets/img/account-01.png'), title: this.$t('account.login.title'), text: this.$t('account.login.text') }
                ]
            }else{
                this.dataList = [
                    { key: 1, pic: require('@/assets/img/account-01.png'), title: this.$t('account.login.title'), text: this.$t('account.login.text') },
                    { key: 2, pic: require('@/assets/img/account-02.png'), title: this.$t('account.phone.title') },
                    { key: 3, pic: require('@/assets/img/account-03.png'), title: this.$t('account.email.title') },
                    // { key: 4, pic: require('@/assets/img/account-04.png'), title: this.$t('account.dynamic.title'), text: this.$t('account.dynamic.text') },
                    // { key: 7, pic: require('@/assets/img/account-07.png'), title: this.$t('account.hardware.title')},
                    // { key: 5, pic: require('@/assets/img/account-08.png'), title: this.$t('account.FIDO.title'), text: this.$t('account.FIDO.text') },
                    // { key: 8, pic: require('@/assets/img/account-05.png'), title: this.$t('account.FIDOU2F.title')},
                    // { key: 9, pic: require('@/assets/img/account-09.png'), title: this.$t('account.webAuthn.title'), text: this.$t('account.webAuthn.text') },
                    // { key: 10, pic: require('@/assets/img/account-10.png'),title: this.$t('account.fastLogin.title'), text: this.$t('account.fastLogin.text') },
                    // { key: 6, pic: require('@/assets/img/account-06.png'), title: this.$t('account.setting.title'), text: this.$t('account.setting.text') },
                ]
            }
            getUserAccountSecurity().then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    if (res.data.existEmail) {
                        let emailKey = res.data.email.match(/(\S*)@/)[1]
                        let emailData = res.data.email.match(/@(\S*)/)[0]
                        res.data.emailCopy = emailKey.slice(0,1)+'****'+emailData
                    }

                    this.obgData = res.data
                    this.existPwd = res.data.existPwd
                    this.existPhone = res.data.existPhone
                    this.existEmail = res.data.existEmail
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },
        getState() {
            // 令牌物理类型，0硬件令牌、1手机令牌、2微信令牌、3 IPT令牌、4脸谱令牌、5声纹令牌、6短信令牌、7 u2f令牌、8指纹令牌、9 uaf令牌,10,fido2(webAuthn)
            getUserActivationStatus().then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    this.FIDOType = res.data.indexOf(9) > -1 ? true: false
                    this.dynamicType = res.data.indexOf(1) > -1 ? true: false
                    this.hardwareType = res.data.indexOf(0) > -1 ? true: false
                    this.FIDOU2FType = res.data.indexOf(7) > -1 ? true: false
                    this.windowsHello = res.data.indexOf(10) > -1 ? true: false
                    if(res.data.length > 0) {
                        let num = 0
                        let num2 = 0
                        let num3 = 0
                        for(let item of res.data) {
                            if(item == 0) {
                                num ++
                            }
                            if(item == 7) {
                                num2 ++
                            }
                            if(item == 10) {
                                num3 ++
                            }
                        }
                        this.otpNum = num
                        this.FIDOU2FNum = num2
                        this.FIDOU2WebAuthnNum= num3
                    }
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },
        rowFun(item) {
            // 判断fido和otp重置时是否有手机号
            console.log(item)
            if((item.key == 5 && this.FIDOType && !this.obgData.mobile) || item.key == 4 && this.dynamicType && !this.obgData.mobile) {

                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: this.$t('account.noPhone'),
                    colorType: 'error'
                })
            }  else if(item.key != 10) {
                // 判断WebAuthn是否是绑定状态
                // if(this.windowsHello) {
            //         this.visible = true
            //         this.activeKey = item.key
            //         this.setTitle(item)
            //
            //         // this.WebAuthnFun()
            //     // }
            //     console.log('=========', "FIDO2（WebAuthn）身份验证器");
            // } else {
                this.visible = true
                this.activeKey = item.key
                // this.modalTitle = item.title
                // this.dataType = item.type
                this.setTitle(item)
            }
        },
        // 设置弹框标题
        setTitle(val) {
            switch(val.key) {
                case 1:
                    this.modalTitle = this.existPwd ? this.$t('account.login.editPwd') : this.$t('account.login.setPwd')
                    this.modalWidth = '31%'
                    break
                case 2:
                    this.modalTitle = this.existPhone ? this.$t('account.phone.editPhone') : this.$t('account.phone.title')
                    this.modalWidth = '31%'
                    break
                case 3:
                    this.modalTitle = this.existEmail ? this.$t('account.email.editEmail') : this.$t('account.email.title')
                    this.modalWidth = '31%'
                    break
                case 4:
                    this.modalTitle = this.dynamicType == 1 ? this.$t('account.dynamic.resetDynamic') : this.$t('account.dynamic.activateDynamic')
                    this.modalWidth = this.dynamicType == 1 ? '31%' : '40%'
                    break
                case 5:
                    this.modalTitle = this.FIDOType ? this.$t('account.FIDO.resetFIDO') : this.$t('account.FIDO.activateFIDO')
                    this.modalWidth = this.FIDOType ? '31%' : '40%'
                    break
                case 6:
                    this.modalTitle = this.$t('account.setting.title')
                    this.modalWidth = '50%'
                    break
                case 7:
                    this.modalTitle = this.hardwareType ? this.$t('account.hardware.bindOrUnbindOtp') : this.$t('account.hardware.bindToken')
                    this.modalWidth = '31%'
                    break
                case 8:
                    this.modalTitle = this.FIDOU2FType ? this.$t('account.FIDOU2F.bindOrUnbindFIDOU2f') : this.$t('account.FIDOU2F.bindToken')
                    // this.modalTitle = this.$t('account.hardware.bindOrUnbind')
                    this.modalWidth = '31%'
                    break
                case 9:
                    this.modalTitle = this.windowsHello ? this.$t('account.webAuthn.unbind') : this.$t('account.webAuthn.bind')
                    this.modalWidth = '31%'
                    break
            }
        },
        handleCancel() {
            let funKey = 'handleCancel'+ this.activeKey
            this.$root.eventHub.$emit(funKey);
            this.$nextTick(()=>{
                this.visible = false
            })
        },
        // loginSub() {
        //     this.dataList[this.activeKey].type = 1
        //     this.dataList[this.activeKey].tip = '已设置'
        //     this.visible = false
        // },
        dynamicFun(token) {
            // if(token) {
                checkMobileToken({
                    token: token
                }).then(res=> {
                    if (res.code == this.$GLOBA.StatusOK) {
                        if(res.message != "ok") {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'success'
                            })
                            // this.dataList[this.activeKey].type = 1
                            // this.dataList[this.activeKey].tip = '已激活'
                            // this.dataList[this.activeKey].typeName = '修改'
                            setTimeout(() => {
                                this.visible = false
                                this.getState()
                            }, 500)
                        }else{
                            setTimeout(() => {
                                this.visible = false
                                this.getState()
                            }, 500)
                        }
                    } else {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                })
            // }else {
            //     this.visible = false
            //     this.getState()
            // }

        },
        FIDOFun() {
            this.visible = false
            this.getState()
        },
        onSubmit() {
            this.getState()
            this.getData()
            this.handleCancel()
        },
        handleClose(){
            this.getState()
            this.getData()
            this.handleCancel()
        },
        getJurisdiction() {
            //是否显示修改密码页面
            this.$userEditPwdFun().then(key=> {
                this.showEditPwd = key
            })
        },
        WebAuthnFun() {

        }
    },
}
</script>

<style lang='scss' scoped>
.account {
    // background: #FFFFFF;
    box-shadow: 0px 0px 46px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    height: 100%;
    // overflow: auto;
    padding: 0px 0px 10px;
    .sub-title {
        font-size: 18px;
        font-weight: 600;
        padding: 8px 0 8px 30px;
        display: flex;
        align-items: center;
        border-radius: 6px 6px 0 0;
        margin-bottom: 30px;
        span {
            margin-left: 10px;
        }
    }
    .sub-title-l {
      background: #dce0f9;
      color: #333;
    }
    .sub-title-d {
      border-bottom: 1px solid #f0f0f0;
    }
    .title {
        padding: 25px 0 40px 40px;
    }
    .box {
        padding: 0 30px;
        .list {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            // height: 120px;
            background: rgb(220 224 249 / 30%);
            border-radius: 10px 10px 10px 10px;
            .text-box {
                // flex: 1;
                // padding: 0 30px;
                font-size: 16px;
                // width: 71%;
                // margin-right: 20px;
                .item-title {
                    font-weight: 600;
                    padding-bottom: 5px;
                    font-size: 16px;
                    color: #333;
                }
                .text {
                    font-weight: 500;
                    color: #999;
                    font-size: 14px;
                }
            }
            .btn-group ::v-deep {
                // position: relative;
                // right: -15px;
                .ant-btn {
                    line-height: 1;
                    font-size: 14px;
                    padding: 0 15px;
                }
            }
            .tip {
                width: 82px;
                text-align: center;
                font-size: 16px;
                font-weight: 500;
                color: #666666;
                margin-right: 100px;
                .success-icon {
                    margin-bottom: 8px;
                }
            }
        }
        .list-d {
          background: #3B355A;
          box-shadow: 0 4px 8px -4px rgb(19 17 32 / 42%) !important;
          .item-title {
              color: rgba(231, 227, 252, 0.68) !important;
          }
        }

    }
}
::v-deep .ant-btn-round{
    margin-right: 32px;
    border-radius: 6px;
    background: #5066e0;
}
::v-deep .ant-modal-title{
    line-height: 29px;
    margin-left: 16px;
    font-weight: bold;
    font-size: 18px;
}
::v-deep .ant-modal-title::before{
    content: "";
    background-image: url(../../assets/img/border.png);
    // line-height: 29px;
    // margin-left: 16px;
    background-size: 100% 100%;
    width: 4px;
    position: absolute;
    top: 24px;
    left: 30px;
    height: 16px;
}
::v-deep .ant-btn-primary{
    background: #5066e0;
}
::v-deep .ant-col-offset-6{
    text-align: center;
}
.color_bg{
    color: #fff;padding: 5px 0px;border-radius: 5px;font-size: 14px;
}
.drawer-header {
    border-bottom: 1px solid #f0f0f0;
}
::v-deep .row {
    align-items: center;
}
.linkSty{
    color: #fff;
    display: inline-block;
    text-decoration: none;
    // width: 103px;
    font-size: 14px;
    padding: 0 16px;
    height: 30px;
    border-radius: 5px;
    line-height: 30px;
    text-align: center;
    background: #5066e0;
}
@media screen and (min-width: 320px) and (max-width: 480px){
    ::v-deep .v-btn:not(.v-btn--round).v-size--default{
        padding: 0 14px;
    }
    ::v-deep .v-btn__content{
        font-size: 13px;
    }
    ::v-deep .v-application.theme--light .v-sheet.v-card:not(.v-sheet--outlined){
        max-height: 100%;
        overflow: hidden;
    }
    ::v-deep .v-card > *:last-child:not(.v-btn):not(.v-chip):not(.v-avatar){
        text-align: center;
        /*max-height: 505px;*/
        overflow: auto;
    }
    .linkSty{
        // width: 92px;
    }
}

</style>
